import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UtilService } from 'src/app/services/util/util.service';

interface Testimonial {
    name: string;
    title: string;
    quote: string;
}

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnDestroy {
    public subscriptions: Subscription[] = [];
    public screenMode: string;
    public isMobile: boolean = false;

    public testimonials: Testimonial[] = [
        {
            name: 'Mirte',
            title: 'geriatrie verpleegkundige',
            quote: '“Hier ontdekte ik welke zorgfuncties er allemaal zijn, en kun je ze ook nog vergelijken. Heel handig.”',
        },
        {
            name: 'Egbertina',
            title: 'geestelijk verzorger',
            quote: '“Door inzicht in al die functies en opleidingen zie je dat er echt meer mogelijk is dan je denkt.”',
        },
        {
            name: 'Jessica',
            title: 'verpleegkundige in opleiding',
            quote: '“De uitgebreide informatie, zoals welk salaris bij een functie hoort, helpt me.”',
        },
        // {
        //     name: 'Geoffrey',
        //     title: 'zorgcoördinator',
        //     quote: '“De persoonlijke verhalen en tips vind ik erg motiverend. Top.”',
        // },
        // {
        //     name: 'Ali',
        //     title: 'helpende zorg en welzijn',
        //     quote: '“Het voelde alsof ik vastliep. Hier vond ik ideeën voor hoe ik verder kan groeien.”',
        // },
        // {
        //     name: 'Rashida',
        //     title: 'verzorgende IG',
        //     quote: '“Het is fijn dat iedereen hier iets aan heeft, wat je achtergrond ook is.”',
        // },
        // {
        //     name: 'Miguel',
        //     title: 'huishoudelijk ondersteuner',
        //     quote: '“Nu weet ik dat ik kan doorgroeien. Het heeft mijn blik op de toekomst veranderd.”',
        // },
    ];

    public currentSlide = 0;

    // Navigate to the previous slide
    public prevSlide(): void {
        this.currentSlide = (this.currentSlide === 0) ? this.testimonials.length - 1 : this.currentSlide - 1;
        const testimonials = document.querySelectorAll('.testimonial');
        testimonials[this.currentSlide].setAttribute('style', `--value: -120px`);
    }

    // Navigate to the next slide
    public nextSlide(): void {
        this.currentSlide = (this.currentSlide === this.testimonials.length - 1) ? 0 : this.currentSlide + 1;
        const testimonials = document.querySelectorAll('.testimonial');
        testimonials[this.currentSlide].setAttribute('style', `--value: 120px`);
    }

    public constructor(
        private utilService: UtilService,
    ) {
        this.subscriptions.push(
            utilService.getScreenMode$().subscribe((screenMode: any) => {
                this.screenMode = screenMode;
                this.isMobile = !screenMode.includes('DESKTOP');
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
    }
}
